import { useMemo } from 'react';

import { useGetSitesInventoryHealth } from '@/dataAccess/rest';
import { useConfigStore } from '@/stores';

import type { SiteCardItem } from './siteCardsGroup/siteCardsGroup.types.ts';
import { splitSitesByHealth } from './siteSelectorModal.utils.ts';

type UseAvailableSitesProps = {
  sites: SiteCardItem[];
  enabled?: boolean;
};

export const useAvailableSites = ({ sites, enabled = true }: UseAvailableSitesProps) => {
  const probeSites = useMemo(() => sites.map(item => item.site), [sites]);
  const portableMode = useConfigStore(s => s.portableMode);
  const healthBySiteId = useGetSitesInventoryHealth({
    sites: probeSites,
    enabled: Boolean(portableMode) && enabled,
  });

  return useMemo(() => splitSitesByHealth(sites, healthBySiteId), [healthBySiteId, sites]);
};
